export default __webpack_public_path__ + "static/media/ContactArrowDown.0e125a38.svg";